import { render, staticRenderFns } from "./HistoricCommentsLift.vue?vue&type=template&id=70db5260&scoped=true"
import script from "./HistoricCommentsLift.vue?vue&type=script&lang=js"
export * from "./HistoricCommentsLift.vue?vue&type=script&lang=js"
import style0 from "./HistoricCommentsLift.vue?vue&type=style&index=0&id=70db5260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db5260",
  null
  
)

export default component.exports